import { render, staticRenderFns } from "./add-download.vue?vue&type=template&id=3beb3061&scoped=true"
import script from "./add-download.vue?vue&type=script&lang=js"
export * from "./add-download.vue?vue&type=script&lang=js"
import style0 from "./add-download.vue?vue&type=style&index=0&id=3beb3061&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beb3061",
  null
  
)

export default component.exports